// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { makeEvent } from "~/lib/signals";
import ContentOverlay from "~/content.overlay";
import { _ } from "~/i18n";

Mapy.UserProfile = class extends ContentOverlay {
	constructor() {
		super();
		this._contentName = "user-profile";
		this._dom = {
			container: node("div", { className: "user-profile" }),
		};
		this._buildCloseButton();

		this._profile = null;
		this._loadPromise = null;
	}

	activate() {
		if (this.isActive()) {
			while (Mapy.active[0] instanceof ContentOverlay && Mapy.active[0] !== this) {
				Mapy.active[0].deactivate();
			}
			this.show();

			return this;
		}

		var thisSuper = super.activate();

		this._load().then(() => {
			this._profile.activate();
			makeEvent("userprofile-activated");
		}, () => {});

		return thisSuper;
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		if (this._profile) {
			this._profile.deactivate();
		}

		this._dom.container.remove();
		makeEvent("userprofile-deactivated");

		return super.deactivate();
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);
		if (this._profile) {
			this._profile.show();
		}

		return super.show();
	}

	hide() {
		if (this._profile) {
			this._profile.hide();
		}
	}

	async setState(state) {
		if (state.up) {
			this.activate();
		} else {
			this.deactivate();
		}

		try {
			await this._load();
			this._profile.setState(state || {});
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.log(ex);
			// TODO: mozna dat nejak vedet, ze se to nepovedlo nacist?
		}
	}

	getState() {
		return this._profile ? this._profile.getState() : {};
	}

	// eslint-disable-next-line class-methods-use-this
	setBottomPanel() {
		// FIXME: asi se nepouziva
	}

	_load() {
		if (!this._loadPromise) {
			Mapy.getComponent("loader").start(true);
			this._loadPromise = import(
				/* webpackChunkName: "userprofile" */
				"~/userprofile/main.ts"
			);
			this._loadPromise.then((module) => {
				this._profile = new module.default(this);
				this._dom.container.appendChild(this._profile.container);
			}, () => {}).finally(() => {
				Mapy.getComponent("loader").end(true);
			});
		}

		return this._loadPromise;
	}

	/**
	 * Vraci objekt s nody, ktere se maji pouzit pro tisk
	 */
	// eslint-disable-next-line class-methods-use-this
	getPrintNodes() {
		return {
			title: Mapy.Util.node("div"),
			panel: Mapy.Util.node("div"),
		}
	}

	// eslint-disable-next-line class-methods-use-this
	historyAfterState(state) {
		if ("up" in state) {
			Mapy.getComponent("history").save(true);
		}
	}
}
